import { Theme } from '@mui/material';
import { useInnovyzeTheme } from './innovyzeTheme';
import useWeaveThemeMaterial from './weaveThemeMaterial';
import {
	WeaveResolvedRoles,
	WeaveMetadata,
} from '@weave-design/unresolved-theme';
import { useWeaveThemeContext } from '../WeaveContext';
import { INFO360_THEMES, ThemeMode } from '../theme.types';

interface Args {
	weave?: {
		resolvedRoles: WeaveResolvedRoles;
		metadata: WeaveMetadata;
	};
}

export default function useDefaultTheme({ weave }: Args): Theme | null {
	const { theme } = useWeaveThemeContext();
	const mode =
		theme === INFO360_THEMES.Dark ? ThemeMode.Dark : ThemeMode.Light;

	// Get theme objects.
	const innovyzeTheme = useInnovyzeTheme();
	const { theme: weaveTheme } = useWeaveThemeMaterial(weave, mode);

	return theme === INFO360_THEMES.Classic ? innovyzeTheme : weaveTheme;
}
